import React from "react";
import { useLocation } from "react-router-dom";

const Notifications = () => {
  const { alerts } = useLocation().state;
  console.log(alerts);
  return (
    <div className="w-full h-full rounded-lg overflow-hidden flex  justify-center">
      {/* {alerts.map(({ device, message }, i) => (
        <div key={i}></div>
      ))} */}
      <table className="border-collapse w-[700px] h-fit bg-header/40">
        <thead>
          <tr className="bg-header">
            <th className="border border-main">Device</th>
            <th className="border border-main">Message</th>
          </tr>
        </thead>

        <tbody>
          {alerts.map(({ device, message }, i) => (
            <tr key={i} className=" ">
              <td className="border border-main px-2">{device}</td>
              <td className="border border-main px-2">{message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Notifications;
